export const BASE_URL = 'https://api-admin-v1.serverpoint.com';